import React from 'react'


const Footer = () => {
  return (
    <div className='footer'>
        {/* <p>Created and designed by Barbone <span className='it'>IT</span> Solutions, LLC</p> */}
        <p>Created and designed for private use only by Joseph Barbone</p>
        <p>Icons by <a href='http://flaticon.com' target='_new'>FlatIcon</a></p>
        {/* <p><a href="https://www.flaticon.com/free-icons/delete" title="delete icons">Delete icons created by IYAHICON - Flaticon</a></p> */}
        <p>Logo by <a href='http://brandcrowd.com' target='_new'>Brand Crowd</a></p>
    </div>
  )
}

export default Footer